import * as wsRequests from "./ws-requests";
import * as Utils from "../_ws/utils";
import * as GTM4Enum from "./GTM4Enum";
import * as WsCommandEnum from "../_ws/WsCommandEnum";

$.validator.addMethod('strongPassword', function (value, element) {
    const errorLabels = {
        length: 'Minimum 8 znaków',
        minor: 'Wymagana choć jedna mała litera',
        major: 'Wymagana choć jedna duża litera',
        digit: 'Wymagana choć jedna cyfra',
        special: 'Wymagana choć jeden znak specjalny'
    };
    const errors = {length: false, minor: false, major: false, digit: false, special: false};

    errors.length = (value.length < 8);
    errors.minor = (null === value.match(/[a-z]/));
    errors.major = (null === value.match(/[A-Z]/));
    errors.digit = (null === value.match(/\d/));
    errors.special = (null === value.match(/\W/));

    let container = null;
    if (typeof element.dataset.plDescriptionTarget !== 'undefined') {
        const c = $(element.dataset.plDescriptionTarget);
        if (c.length === 1) {
            container = c;
        }
    }

    const messages = [];

    let hasNoErrors = true;
    Object.keys(errors).forEach((key) => {
        if (container !== null) {
            const e = container.find('.status-line.' + key);
            if (e.length === 1) {
                e.removeClass('valid inValid');
                e.addClass(errors[key] ? 'inValid' : 'valid');
            }
        }
        if (errors[key]) {
            hasNoErrors = false;
            messages.push(errorLabels[key]);
        }
    });

    if (container === null) {
        $.validator.messages['strongPassword'] = messages.join(', ');
    }

    return hasNoErrors;
}, 'Wprowadź silne hasło!');

/**
 * Polski NIP: 10 cyfr + suma kontrolna (wagi 6,5,7,2,3,4,5,6,7, mod 11).
 * Odpowiada serwerowemu Proline\Validator\Nip; renderer wystawia data-rule-nipPL.
 */
const isValidNipPL = function (nip) {
    if (typeof nip !== 'string') {
        return false;
    }
    const clean = nip.replace(/[\s-]/g, '');
    if (!/^\d{10}$/.test(clean) || /^0{10}$/.test(clean)) {
        return false;
    }
    const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    let sum = 0;
    for (let i = 0; i < 9; i++) {
        sum += parseInt(clean[i], 10) * weights[i];
    }

    return (sum % 11) === parseInt(clean[9], 10);
};

$.validator.addMethod('nipPL', function (value, element) {
    return this.optional(element) || isValidNipPL(String(value));
}, 'Nieprawidłowy NIP (błędna suma kontrolna)');

const validateOptions = {
    ignore: ":hidden:not(.validation-dont-ignore), .ignore-val-grp",
    rules: {
        nip: {
            // NIP bywa zagraniczny (CZ12345678, ATU12345678) — wycinamy tylko separatory, litery zostają
            normalizer: function (value) {
                return value.replace(/[\s.\-\/_]/g, '');
            }
        },
        nipPL: {
            normalizer: function (value) {
                value = value.replace(/\D/g, '');
                return value.replace(/-/g, '');
            }
        },
        'additional-equipment[]': {
            required: true
        }
    },
    messages: {
        'additional-equipment[]': {
            required: 'Wybierz co najmniej jedną opcję wyposażenia.'
        }
    },
    errorClass: "is-invalid",
    validClass: "is-valid",
    errorPlacement: function (error, element) {
        if (element.attr('name') === 'additional-equipment[]') {
            element.closest('form').find('#additional-equipment-error ul.feedback-list').append(error);
            element.closest('form').find('#additional-equipment-error').show();
        } else {
            element.attr('aria-invalid', 'true');
            const container = element.closest('form').find('#' + element.attr('id') + '-error ul.feedback-list');
            error.appendTo(container);
            container.closest('.invalid-feedback').show();
        }
    },
    submitHandler: function (form) {
        const formH = $(form);
        const data = formH.find('input[name=productAmount]').val()

        const getArguments = (eventName) => {
            return {
                "event": `${eventName}`,
            }
        }

        if ($(form).data('gtm4')) {
            switch ($(form).data('gtm4')) {
                case GTM4Enum.ADD_TO_CART:
                    const event = {
                        event: GTM4Enum.ADD_TO_CART,
                        currency: "PLN",
                        value: parseFloat(formH.find('input[name=productPrice]').val() * data),
                        items: [{
                            item_id: formH.find('input[name=productId]').val(),
                            item_name: formH.find('input[name=productName]').val(),
                            price: parseFloat(formH.find('input[name=productPrice]').val()),
                            quantity: Number(data),
                            category: formH.find('input[name=category]').val()
                        }]
                    }
                    window.dataLayer.push(event);
                    break;
                case GTM4Enum.SIGN_UP:
                    const signupEvent = getArguments(GTM4Enum.SIGN_UP);
                    signupEvent.method = "Proline.pl";
                    window.gtm4Event = signupEvent;
                    window.dataLayer.push(window.gtm4Event);
                case GTM4Enum.LOGIN:
                    const loginEvent = getArguments(GTM4Enum.LOGIN);
                    loginEvent.method = "Proline.pl";
                    window.gtm4Event = loginEvent;
                    window.dataLayer.push(window.gtm4Event);
                    break;
                case GTM4Enum.REMOVE_ALL_FROM_CART:
                    const removeAllEvent = window.gtm4Event;
                    removeAllEvent.event = GTM4Enum.REMOVE_FROM_CART;
                    window.dataLayer.push(removeAllEvent);
                    break
                case GTM4Enum.ADD_SHIPPING_INFO:
                    const shoppingInfo = JSON.parse(JSON.stringify(window.shoppingInfo));
                    const paymentInfo = JSON.parse(JSON.stringify(window.shoppingInfo));
                    paymentInfo.event = GTM4Enum.ADD_PAYMENT_INFO;
                    window.dataLayer.push(shoppingInfo);
                    window.dataLayer.push(paymentInfo);
                    break
                case GTM4Enum.REMOVE_FROM_CART:
                    const productId = formH.find('input[name=productId]').val();
                    const removedProduct = window.gtm4Event.items.find(item => item.item_id === productId);
                    const removeEvent = {
                        event: GTM4Enum.REMOVE_FROM_CART,
                        currency: "PLN",
                        value: parseFloat(removedProduct.price * removedProduct.quantity),
                        items: Number(removedProduct)
                    };

                    window.dataLayer.push(removeEvent);
                    break
            }
        }
        if ($(form).data('ws') !== undefined && Utils.isWebsocketReady()) {
            $(form).on('submit', function (e) {
                e.preventDefault();
                return false;
            });
            wsRequests.webSocketAction(form);
        } else {
            return true;
        }
    }
};

const validateForm = function (form) {
    $(form).validate(validateOptions);
}

const validateForms = function (form) {
    $(form).each(function (e, item) {
        $(item).validate(validateOptions);
    });
}

const ZIP_PL_COUNTRY_ID = '167';

const applyZipMask = function (input, countrySelect) {
    const country = countrySelect.length ? String(countrySelect.val() || ZIP_PL_COUNTRY_ID) : ZIP_PL_COUNTRY_ID;
    if (country === ZIP_PL_COUNTRY_ID) {
        $(input).mask('00-000');
    } else {
        $(input).unmask();
    }
};

const maskZipByCountry = function (zipName, countryName) {
    $('input[name="' + zipName + '"]').each(function () {
        const input = this;
        const countrySelect = $(input).closest('form').find('select[name="' + countryName + '"]');
        applyZipMask(input, countrySelect);
        countrySelect.off('change.zipMask').on('change.zipMask', function () {
            applyZipMask(input, countrySelect);
        });
    });
};

const inputsMask = function () {
    if ($("#nipNip").length > 0) {
        $("#nipNip").mask('0000000000');
    }

    // adres faktury może być zagraniczny — maska XX-XXX tylko przy Polsce w tym samym formularzu
    maskZipByCountry('zip', 'countries');
    maskZipByCountry('zipFv', 'countriesFv');

    if ($('input[name="zipDelivery"]').length > 0) {
        $('input[name="zipDelivery"]').mask('00-000');
    }

    if ($('input[name="phone"]').length > 0) {
        $('input[name="phone"]').mask('000000000');
    }
}

const onChangeSubmit = function (form) {
    const formH = $(form);
    formH.find('input[type=radio][name=shipmentKindId]').on('change', function () {
        $(this).closest('form').trigger('submit');
    });
    formH.find('input[type=radio][name=paymentMethodId]').on('change', function () {
        $(this).closest('form').trigger('submit');
    });
    formH.find('select[name=productsAmountId]').on('change', function () {
        $(this).closest('form').trigger('submit');
    });
    formH.find('select[name=sortingTypeId]').on('change', function () {
        $(this).closest('form').trigger('submit');
    });
}

export {
    isValidNipPL,
    validateOptions,
    validateForm,
    validateForms,
    onChangeSubmit,
    inputsMask,
}
